// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Account: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M14 0c7.719 0 14 6.282 14 14 0 7.719-6.281 14-14 14-7.72 0-14-6.281-14-14C0 6.282 6.28 0 14 0zm0 .933C6.792.933.932 6.797.932 14c0 7.204 5.86 13.068 13.068 13.068 7.204 0 13.067-5.864 13.067-13.068C27.067 6.797 21.204.933 14 .933zm0 14.103c3.7 0 6.9 2.163 8.395 5.297A10.5 10.5 0 0114 24.517a10.506 10.506 0 01-8.395-4.18 9.288 9.288 0 018.395-5.3zm-.001-10.105a4.16 4.16 0 110 8.32 4.16 4.16 0 010-8.32z"
            />
        </svg>
    );
};

export default React.memo(Account);
